import { I621Form } from '../api/types'
import { ICockpitPartnerData } from '../model/types'

/** Appends the partner's earned Power Elite tier to `AmplifyTrack`. Priority goes to
 *  `IsPowerEliteGlobal` when both flags are set — a globally-elite partner is never also listed
 *  as plain Power Elite. `PartnerName` becomes `CompanyEnglishName`, so every cockpit shows the
 *  partner's English name; a partner without one keeps its own name. */
export const mapCockpitPartnerFromApi = (
  data: I621Form & Pick<ICockpitPartnerData, 'CompanyEnglishName'>
): ICockpitPartnerData => {
  const membershipTier =
    data.IsPowerEliteGlobal === 1
      ? 'Power Elite Global'
      : data.IsPowerElite === 1
        ? 'Power Elite'
        : ''

  return {
    ...data,
    PartnerName: data.CompanyEnglishName || data.PartnerName,
    AmplifyTrackWithMembership: [data.AmplifyTrack, membershipTier].filter(Boolean).join(', '),
  } as any
}
